export const SOCKET_SEND_ACTION = {
  CreateRoom: 'create_room',
  JoinRoom: 'join_room',
  LeaveRoom: 'leave_room',
  ReturnRoom: 'return_room',
  StartGame: 'start_game',
  UpdateProgress: 'update_progress',
  Restart: 'restart_game',
  Reconnect: 'reconnect',
  Heart: 'heart',
  PvpMode: 'set_pvp_mode',
  PvpUpdateProgress: 'friend_pvp_update_progress',
  PvpLeaveRoom: 'friend_pvp_leave',
  PvpResult: 'friend_pvp_result'

  // Find: 'find',
  // NewQuiz: 'new quiz',
  // Choose: 'choose'
}

export const SOCKET_RECEIVE_ACTION = {
  CreateRoom: 'create_room',
  JoinRoom: 'join_room',
  LeaveRoom: 'leave_room',
  ReturnRoom: 'return_room',

  // GameStart: 'game start',

  DispatcherConfig: 'dispatcher_config',

  UpdateProgress: 'update_progress',
  // NewQuiz: 'new quiz',
  // ChooseResult: 'choose result',
  // EnemyResult: 'enemy result',

  GameResult: 'game_result',
  Restart: 'restart_game',  
  Error: 'error',
  SocketClosed: 'socket_closed',
  Reconnect: 'reconnect',
  Heart: 'heart',
  PvpUpdateProgress: 'friend_pvp_update_progress',
  PvpLeaveRoom: 'friend_pvp_leave',
  PvpResult: 'friend_pvp_result',
  PvpRobotResult: 'friend_pvp_robot_result'
}
